<template lang="pug">
  .banner
</template>

<style lang="scss" scoped>
  .banner {
    position: relative;
    display: block;
    width: 100%;
    height: 250px;
    background-image: url('../../../static/banner.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>

<script>
export default {
  name: 'banner'
}
</script>



// WEBPACK FOOTER //
// Banner.vue?b3b6d82e